import { render, staticRenderFns } from "./UsersBalancesContainer.vue?vue&type=template&id=24daeac4&scoped=true&"
import script from "./UsersBalancesContainer.vue?vue&type=script&lang=js&"
export * from "./UsersBalancesContainer.vue?vue&type=script&lang=js&"
import style0 from "./UsersBalancesContainer.vue?vue&type=style&index=0&id=24daeac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24daeac4",
  null
  
)

component.options.__file = "UsersBalancesContainer.vue"
export default component.exports